import React from 'react';
import Proptypes from 'prop-types';
import _ from 'lodash'
import { getPDBByModelId, getFirByModelId, getLogByModelId } from '../../api/ispyb';
import { getFileName } from '../../helpers/Saxs/SaxsGeneralHelper';


class SaxsAbInitioTable extends React.Component {
    render() {

        const getModels = () => {
            let result = [];

            _.map(this.props.subtractions, subtraction =>
                _.map(subtraction.abInitioModels, abInitioModel => {

                    if (abInitioModel.averagedModel != null) {
                        result.push(<AbInitioTableRow model={abInitioModel.averagedModel} firstRowText='Reference'
                            subtractionId={subtraction.subtractionId} proposal={this.props.proposal} token={this.props.token} />)
                    }

                    if (abInitioModel.shapeDeterminationModel != null) {
                        result.push(<AbInitioTableRow model={abInitioModel.shapeDeterminationModel} firstRowText='Refined'
                            subtractionId={subtraction.subtractionId} proposal={this.props.proposal} token={this.props.token} />)
                    }

                    if (abInitioModel.modelList != null) {
                        if (abInitioModel.modelList.models != null) {
                            abInitioModel.modelList.models.forEach(model => {
                                result.push(<AbInitioTableRow model={model} firstRowText='Model'
                                    subtractionId={subtraction.subtractionId} proposal={this.props.proposal} token={this.props.token} />)
                            });
                        }
                    }
                })
            )
            return result;
        }

        return (<table className="table table-striped table-hover">
            <thead>
                <tr>
                    <th >Type</th>
                    <th >chiSqrt</th>
                    <th >rFactor</th>
                    <th >Rg</th>
                    <th >PDB</th>
                    <th >Fir</th>
                    <th >Log</th>
                </tr>
            </thead>
            <tbody> {getModels()} </tbody>
        </table>)
    }
}

export default SaxsAbInitioTable;

SaxsAbInitioTable.proptypes = {
    /* proposal name */
    proposal: Proptypes.string,
    /* subtraction list */
    subtractions: Proptypes.array,
    /* ispyb authentication token */
    token: Proptypes.string
}


/* React compoent which render a row of the abinitio table */
const AbInitioTableRow = (props) => {
    return (<tr>
        <td> {props.firstRowText} </td>
        <td> {props.model.chiSqrt} </td>
        <td> {props.model.rfactor} </td>
        <td> {props.model.rg} </td>
        <td>
            <a href={getPDBByModelId(props.token, props.proposal, props.subtractionId, props.model.modelId)} target='_blank'>
                {getFileName(props.model.pdbFile, false)}
            </a>
            {/* <a href='../viewer/uglymol/index.html?pdb={.pdbURL}' target='_blank'>
                <span class="glyphicon glyphicon-eye-open"></span>
            </a> */}
        </td>
        <td>
            <a href={getFirByModelId(props.token, props.proposal, props.subtractionId, props.model.modelId)} target='_blank'>
                {getFileName(props.model.firFile, false)}
            </a>
        </td>
        <td>
            <a href={getLogByModelId(props.token, props.proposal, props.subtractionId, props.model.modelId)} target='_blank'>
                {getFileName(props.model.logFile, false)}
            </a>
        </td>
    </tr>)
}



// WEBPACK FOOTER //
// ./src/components/saxs/SaxsAbInitioTable.js